<template>
  <v-row justify="center">
    <v-dialog v-model="notificationSendDialog" scrollable max-width="350px">
      <v-card>
        <v-card-title>SMS 알림 발송 이력</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px;" class="pb-7">
          <template v-for="(item, key) in logList">
            <div :key="key">
              <p class="mb-0 font-weight-bold body-2 mt-9 black--text">
                {{ item.member_id }} (인증회원) SMS 발송
              </p>
              <p class="mb-0 caption text-truncate mt-1">
                <font>{{ item.sent_at }}</font>
              </p>
            </div>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="notificationSendDialog = false"
            >닫기</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      notificationSendDialog: false,
      logList: [],
    };
  },
  mixins: [CommonMixin],
  methods: {
    notificationSend: async function(item) {
      let res = await M.api(M.entry("/lost/serials/sms", item.serial_number));
      if (res.length === 0) {
        this.alertShow("알림 발송 이력이 없습니다.");
      } else {
        this.logList = res;
        this.notificationSendDialog = true;
      }
    },
  },
};
</script>
